<template>
	<el-dialog title="选择商品" :visible.sync="comShow" width="40%" @close="comClose" center>
		<div v-for="(item, index) in addList">
			<template>
				<el-row><span style="font-weight: 600;" :span="24">商品{{ index + 1 }}:</span></el-row>
				<el-row>
					<el-col :span="5">
						<span>商品名称：</span>
					</el-col>
					<el-col :span="15">
						<el-input size="mini" v-model="item.productName"></el-input>
					</el-col>
					<el-col :span="4">
						<el-button style="margin-left: 10px; height: 28px; align-items: center; line-height: 5px;"
							type="danger" @click="deleteGood(index)">删除</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="5">
						<span>价格：</span>
					</el-col>
					<el-col :span="5">
						<el-input :disabled="true" size="mini" v-model="item.productPrice"></el-input>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="5">
						<span>上架时间：</span>
					</el-col>
					<el-date-picker size="mini" v-model="item.productStartTime" type="datetime"
						format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="上架时间">
					</el-date-picker>
				</el-row>
				<el-row>
					<el-col :span="5">
						<span>下架时间：</span>
					</el-col>
					<el-date-picker size="mini" v-model="item.productEndTime" type="datetime"
						format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="下架时间">
					</el-date-picker>
				</el-row>
				<el-row>
					<el-col :span="5">
						<span>商品图片：</span>
					</el-col>
					<el-image style="width: 100px; height: 100px" :src="item.productPic">

					</el-image>
				</el-row>
			</template>
		</div>
		<template>
			<el-row>
				<div @click="addGoods">
					<i class="el-icon-plus"></i> <span>注：最多添加10个商品</span>
				</div>
			</el-row>
			<el-row>
				<el-button type="success" @click="addOk">确认</el-button>
				<el-button type="danger" @click="addNo">取消</el-button>

			</el-row>
		</template>


		<!--        start-->
		<el-row>
			<!-- 选择商品 -->
			<el-col :span="24">
				<el-drawer title="查询商品" :visible.sync="table" :append-to-body=true direction="rtl" size="50%"
					style="overflow: auto">
					<div style="margin-top: 20px; margin-bottom: 20px; overflow: auto">
						<span style="margin: 20px">商品名称</span>
						<el-input v-model="keyword" size="mini" style="width: 200px; margin-right: 20px" />
						<el-button size="small" @click="searchProduct(true)">
							搜索
						</el-button>
					</div>
					<div>
						<div style="overflow: auto">
							<el-table :data="tableDataProduct" border style="width: 99%">
								<el-table-column prop="id" label="商品id" align="center" />
								<el-table-column prop="code" label="货号" align="center" />
								<el-table-column label="缩略图" align="center">
									<template slot-scope="scope">
										<el-image :src="
                                            tableDataProduct[scope.$index].pics.split(',')[0] +
                                            '?x-oss-process=image/resize,w_50'
                                        " fit="fill" :preview-src-list="scope.row.preview" />
									</template>
								</el-table-column>
								<el-table-column prop="name" label="商品名称" align="center" />
								<el-table-column prop="price" label="价格" align="center" />
								<el-table-column label="原料状态" align="center">
									<template slot-scope="scope">
										<span>{{
                                                tableDataProduct[scope.$index].materielType === 1
                                                    ? "成品"
                                                    : "原料"
                                        }}</span>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<el-button type="danger" size="mini" @click="clickProductIs(scope.row)">
											选择
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
						:page-size="pageSize2" :page-sizes="[30, 50, 100]" :total="total2" :current-page.sync="pageNum2"
						@size-change="handleSizeChange2" @current-change="handleCurrentChange2" />
				</el-drawer>
			</el-col>
		</el-row>


	</el-dialog>
</template>

<script>
	export default {
		props: {
			comShow: {
				type: Boolean,
				default: false
			},
			addList: {
				type: Array,
				default: null
			}
		},
		data() {
			return {
				isadd: 1, // 1 add 2 update
				table: false, // 商品弹窗
				//addList: [],
				pageNum2: 1,
				pageSize2: 10,
				pageSize: 10,
				pageNum: 1,
				total2: 0,
				keyword: '',
			}
		},
		created() {
			this.searchProduct(false);
		},
		methods: {
			deleteGood(index) {
				this.addList.splice(index, 1);
			},
			addNo() {
				//this.addList = [];
				this.comShow = false;
				this.$emit('comClose', false)
			},
			addOk() {
				this.comShow = false;
				this.$emit('sendMes', this.addList)
				this.$emit('comClose', false)
				this.addList = [];
			},
			addGoods() {
				if (this.addList.length >= 10) {
					this.table = false;
					alert("最多添加10个商品");
				} else {
					this.table = true;
				}
			},
			clickProductIs(result) {
				if (this.isadd == 1) {
					let newData = {
						productName: result.name,
						productId: result.id,
						productStartTime: '',
						productEndTime: '',
						productPic: result.pics.split(",")[0],
						productPrice: result.price
					}
					this.addList.push(newData);
				} else {
					let newData = {
						productName: result.name,
						productId: result.id,
						productStartTime: '',
						productEndTime: '',
						productPic: result.pics.split(",")[0],
						productPrice: result.price
					}
					this.addList.push(newData);
				}
				this.table = false;
			},
			comClose() {
				this.comShow = false
				this.$emit('comClose', false)
			},
			// 查询商品
			searchProduct(ischange) {
				if (ischange) {
					this.pageNum2 = 1;
				}
				let url = "/api/product/product/product";
				return this.$http
					.get(url, {
						params: {
							pageNum: this.pageNum2,
							pageSize: this.pageSize2,
							keyword: this.keyword,
							// status:''
							sort: -1,
						},
					})
					.then((res) => {
						console.log(JSON.stringify(res.data.data.list) + "======goods======");
						this.tableDataProduct = res.data.data.list;
						this.tableDataProduct.forEach((item, index) => {
							item.preview = [];
							item.preview = item.pics.split(",");
						});
						this.total2 = res.data.data.total;
					});
			},
			handleSizeChange2(val) {
				this.pageSize2 = val;
				this.searchProduct(false);
			},
			handleCurrentChange2(val) {
				this.pageNum2 = val;
				this.searchProduct(false);
			},
			//pagesize改变
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getTable();
			},

			//页码改变
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getTable();
			},
		}
	}
</script>

<style scoped>

</style>
